import * as createAccount from 'store/actions/accounts/createAccounts';
import * as fetchAccount from 'store/actions/accounts/fetchAccounts';
import * as updateAccount from 'store/actions/accounts/updateAccounts';
import * as deleteAccount from 'store/actions/accounts/deleteAccounts';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, select, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

const getAccountStore = (state) => {
    return state.accounts;
};

function* fetchAccountsAccumulatedAsync({ payload }) {
    const params = payload.params || {
        size: payload.size,
        offset: payload.offset,
        sort_by: payload.sort.field,
        sort_direction: payload.sort.order,
    };

    try {
        const url = `${ config.getApiBaseUrl() }/accounts`;

        const response = yield apiClient.read(url, params);

        yield put(fetchAccount.fetchAccountsSuccess(response));
    } catch (error) {
        yield put(fetchAccount.fetchAccountsFailure(error));
    }
}

function* fetchAccountsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/accounts`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchAccount.fetchAccountsSuccess(response));
    } catch (error) {
        yield put(fetchAccount.fetchAccountsFailure(error));
    }
}

function* fetchAccountAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/accounts/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchAccount.fetchAccountSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(fetchAccount.fetchAccountFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createAccountAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/accounts`;
        const response = yield apiClient.create(url, values);

        yield put(createAccount.createAccountSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess(response);
        }
    } catch (error) {
        yield put(createAccount.createAccountFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createAccountSuccessAsync() {
    yield put(showNotification('notifications.accounts.create.success'));
}

function* updateAccountAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/accounts/${ id }`;
        const response = yield apiClient.patch(url, values);

        yield put(updateAccount.updateAccountSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess(response);
        }
    } catch (error) {
        yield put(updateAccount.updateAccountFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* updateAccountSuccessAsync() {
    yield put(showNotification('notifications.accounts.update.success'));
}

function* deleteAccountAsync({ payload }) {
    const { id } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/accounts/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteAccount.deleteAccountSuccess(payload));
    } catch (error) {
        yield put(deleteAccount.deleteAccountFailure(error));
    }
}

function* deleteAccountSuccessAsync() {
    const getAccount = yield select(getAccountStore);

    yield put(fetchAccount.fetchAccounts({
        offset: getAccount.offset,
        page: getAccount.page,
    }));

    yield put(showNotification('notifications.accounts.delete.success', 'success'));
}

function* failureMessage({ payload }) {
    const { message } = payload.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* accountsSagas() {
    yield [
        takeEvery(types.FETCH_ACCOUNTS, fetchAccountsAsync),
        takeEvery(types.FETCH_ACCOUNTS_ACCUMULATED, fetchAccountsAccumulatedAsync),
        takeEvery(types.FETCH_ACCOUNTS_FAILURE, failureMessage),

        takeEvery(types.FETCH_ACCOUNT, fetchAccountAsync),
        takeEvery(types.FETCH_ACCOUNT_FAILURE, failureMessage),

        takeEvery(types.CREATE_ACCOUNT, createAccountAsync),
        takeEvery(types.CREATE_ACCOUNT_FAILURE, failureMessage),
        takeEvery(types.CREATE_ACCOUNT_SUCCESS, createAccountSuccessAsync),

        takeEvery(types.UPDATE_ACCOUNT, updateAccountAsync),
        takeEvery(types.UPDATE_ACCOUNT_FAILURE, failureMessage),
        takeEvery(types.UPDATE_ACCOUNT_SUCCESS, updateAccountSuccessAsync),

        takeEvery(types.DELETE_ACCOUNT, deleteAccountAsync),
        takeEvery(types.DELETE_ACCOUNT_FAILURE, failureMessage),
        takeEvery(types.DELETE_ACCOUNT_SUCCESS, deleteAccountSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/accountsSagas.js